'use strict';

var Sugar = require('sugar-core'),
    objectFilter = require('../enumerable/internal/objectFilter');

Sugar.Object.defineInstanceAndStatic({

  'filter': function(obj, f) {
    return objectFilter(obj, f);
  }

});

module.exports = Sugar.Object.filter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/filter.js
// module id = 774
// module chunks = 0